// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Album__text-ec96f5 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  color: var(--chat-bubble-text-secondary);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MiniatureMessage/Payloads/Album/styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EAEA,wCAAA;EACA,4BAAA;EACA,8CAAA;AAAF","sourcesContent":[".text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n\n  color: var(--chat-bubble-text-secondary);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `Album__text-ec96f5`
};
module.exports = ___CSS_LOADER_EXPORT___;
